/**
 Pusher app key/cluster бэкенда fin-crm-back (см. PUSHER_APP_KEY/PUSHER_APP_CLUSTER в его
 .env, сервер поднят через beyondcode/laravel-websockets — Pusher-совместимый протокол).
 Это НЕ тот же сокет, что window.Echo/connectWebsocket (socket.io, mainchat-бэкенд для чата) —
 у CRM-бэкенда свой Pusher-инстанс, к которому уже подключается 'jobs-...' канал в
 webSocketMiddleware.js; 'progress'-канал в useTrustReportProgress.ts использует тот же
 app key/cluster, чтобы попасть на тот же Pusher-сервер, но свой канал.
 App key публичный (в отличие от app secret, который остаётся только на бэке) — безопасно
 хранить в клиентском коде.
 */
export const CRM_PUSHER_APP_KEY = 'd80a938aded21b41c19d';
export const CRM_PUSHER_CLUSTER = 'eu';
